// src/components/ChatMessagesBox.js
import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import MessageBubble from './MessageBubble';
import { format } from 'date-fns';

const ChatMessagesBox = React.memo(({ messages, currentUserId, height = '400px' }) => {
    const messagesEndRef = useRef(null);
    const initialScrollDone = useRef(false);

    // Scroll to bottom only once, when messages first load
    useEffect(() => {
        if (!initialScrollDone.current && messages.length > 0) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
            initialScrollDone.current = true;
        }
    }, [messages]);

    return (
        <Box mt={2} mb={2} sx={{ height, overflowY: 'auto' }}>
            {messages.map((message, index) => (
                <Box key={index} mb={2}>
                    <Typography variant="caption" color="textSecondary">
                        {format(new Date(message.created_at), 'MMM d, yyyy HH:mm')}
                    </Typography>
                    <MessageBubble isCurrentUser={message.sender_id === currentUserId}>
                        {message.content}
                    </MessageBubble>
                </Box>
            ))}
            <div ref={messagesEndRef} />
        </Box>
    );
});

export default ChatMessagesBox;
